import React, { useState } from 'react';
import image1 from '../images/image-product-1-thumbnail.jpg';
import image2 from '../images/image-product-2-thumbnail.jpg';
import image3 from '../images/image-product-3-thumbnail.jpg';
import image4 from '../images/image-product-4-thumbnail.jpg';
import img1 from '../images/image-product-1.jpg';
import img2 from '../images/image-product-2.jpg';
import img3 from '../images/image-product-3.jpg';
import img4 from '../images/image-product-4.jpg';
import './Landingpage.css';
import { cart } from './carts';

export const images = [image1, image2, image3, image4];
export const largeImages = [img1, img2, img3, img4];

const Landingpage = ({carte,setCart,remove,setremove,imgstyle, imgnum, setimage }) => {
  const [quan, setquan] = useState(0);

  const AddtoCart = () => {
    const cartelement = {
      quantity: quan,
      price: 125,
    };
    cart.push(cartelement);
    setCart(cart.length)
  };

  const handledecrement = () => {
    if (quan > 0) {
      setquan(prev => prev - 1);
    }
  };

  const handleincrement = () => {
    setquan(prev => prev + 1);
  };

  const decideimage = (index) => {
    setimage(index); // Use setimage to update imgnum in App component
    const mins = document.getElementsByClassName('min');
    for (let i = 0; i < images.length; i++) {
      mins[i].querySelector('img').classList.remove('add');
      mins[i].style.borderRadius = '5px';
      mins[i].style.border = '';
    }

    const minsimg = mins[index].querySelector('img');
    minsimg.classList.add('add');
    minsimg.style.border = '2px solid hsl(26, 100%, 55%)';
    minsimg.style.borderRadius = '5px';
  };

  return (
    <div className='landingpage'>,
      <div className="imagepage">
        <div className='product-image'>
          <img   className={remove?"product-imagesimg":"product-imageimg"} onClick={()=>setremove(true)} src={largeImages[imgnum]} alt={`Large product ${imgnum + 1}`} />
        </div>

        <div className="productminimage">
          {images.map((img, index) => (
            <div className="min" key={index}>
              <img className={remove?"minimgs":"minimg"}
                onMouseEnter={() => decideimage(index)}
                src={img} 
                alt={`Thumbnail ${index + 1}`} 
              />
            </div>
          ))}
        </div>
      </div>

      <div className="infopage">
        <p>SNEAKER COMPANY</p>
        <h1>Fall Limited Edition<br /> Sneakers</h1>
        
        <div className="para">
          <p>These low-profile sneakers are your perfect casual wear<br /> companion. Featuring a durable rubber outer sole, they’ll<br /> withstand everything the weather can offer.</p>
        </div>
        
        <div className="percentage">
          <h1>$125.00</h1>
          <button>50%</button>
        </div>

        <div className='addtocartandquantity'>
          <div className='quantity'>
            <button onClick={handledecrement} id='decrement'>
              <svg width="12" height="4" xmlns="http://www.w3.org/2000/svg"><path d="M11.357 3.332A.641.641 0 0 0 12 2.69V.643A.641.641 0 0 0 11.357 0H.643A.641.641 0 0 0 0 .643v2.046c0 .357.287.643.643.643h10.714Z" fill="#FF7E1B"/></svg>
            </button>
            <button style={{ fontFamily: "'Kumbh Sans', sans-serif", fontWeight: '700' }}
              id='num'>{quan}</button>
            <button onClick={handleincrement} id='increment'>
              <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg"><path d="M12 7.023V4.977a.641.641 0 0 0-.643-.643h-3.69V.643A.641.641 0 0 0 7.022 0H4.977a.641.641 0 0 0-.643.643v3.69H.643A.641.641 0 0 0 0 4.978v2.046c0 .356.287.643.643.643h3.69v3.691c0 .356.288.643.644.643h2.046a.641.641 0 0 0 .643-.643v-3.69h3.691A.641.641 0 0 0 12 7.022Z" fill="#FF7E1B"/></svg>
            </button>
          </div>
          <div className="addbtn">
            <button onClick={AddtoCart} id='addcartbtn'>
              <svg width="22" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M20.925 3.641H3.863L3.61.816A.896.896 0 0 0 2.717 0H.897a.896.896 0 1 0 0 1.792h1l1.031 11.483c.073.828.52 1.726 1.291 2.336C2.83 17.385 4.099 20 6.359 20c1.875 0 3.197-1.87 2.554-3.642h4.905c-.642 1.77.677 3.642 2.555 3.642a2.72 2.72 0 0 0 2.717-2.717 2.72 2.72 0 0 0-2.717-2.717H6.365c-.681 0-1.274-.41-1.53-1.009l14.321-.842a.896.896 0 0 0 .817-.677l1.821-7.283a.897.897 0 0 0-.87-1.114ZM6.358 18.208a.926.926 0 0 1 0-1.85.926.926 0 0 1 0 1.85Zm10.015 0a.926.926 0 0 1 0-1.85.926.926 0 0 1 0 1.85Zm2.021-7.243-13.8.81-.57-6.341h15.753l-1.383 5.53Z" fill="#69707D" fill-rule="nonzero"/></svg><p>Add to cart</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landingpage;
